/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Best_ForInputs */

const en_directory_detail_best_for = /** @type {(inputs: Directory_Detail_Best_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best for`)
};

const zh_directory_detail_best_for = /** @type {(inputs: Directory_Detail_Best_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合`)
};

/**
* | output |
* | --- |
* | "Best for" |
*
* @param {Directory_Detail_Best_ForInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_best_for = /** @type {((inputs?: Directory_Detail_Best_ForInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Best_ForInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_best_for(inputs)
	return zh_directory_detail_best_for(inputs)
});
export { directory_detail_best_for as "directory.detail.best_for" }